import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Logo";

const field = "h-12 w-full rounded-xl border border-white/10 bg-white/5 px-4 text-sm text-white outline-none focus:border-[#0066FF]";
const btn = "mt-6 h-12 w-full rounded-full bg-[#0066FF] font-medium transition-colors hover:bg-[#1a75ff] disabled:opacity-60";

const Shell = ({ title, children, testid }) => (
  <div className="lt-grid-bg flex min-h-screen items-center justify-center bg-[#0A0B0E] px-4 text-white">
    <div className="w-full max-w-sm rounded-3xl border border-white/10 bg-[#12141A] p-8" data-testid={testid}>
      <Logo tone="dark" />
      <h1 className="mt-8 font-display text-2xl font-semibold">{title}</h1>
      {children}
      <Link to="/admin/login" className="mt-6 block text-center text-sm text-slate-400 hover:text-white" data-testid="back-to-login-link">
        Torna all'accesso
      </Link>
    </div>
  </div>
);

function useSubmit(fn) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(null);
  const run = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      setDone(await fn());
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return { busy, error, done, run };
}

export function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const s = useSubmit(() => api.post("/auth/forgot-password", { email }).then((r) => r.data.message));
  return (
    <Shell title="Password dimenticata" testid="forgot-password-page">
      {s.done ? (
        <p className="mt-6 text-sm text-emerald-400" data-testid="forgot-password-success">{s.done}</p>
      ) : (
        <form onSubmit={s.run} data-testid="forgot-password-form">
          <p className="mt-1 text-sm text-slate-400">Inserisci l'email dell'account amministratore: riceverai un link valido 30 minuti.</p>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={`${field} mt-6`} data-testid="forgot-password-email" />
          {s.error && <p className="mt-4 text-sm text-red-400" data-testid="forgot-password-error">{s.error}</p>}
          <button disabled={s.busy} className={btn} data-testid="forgot-password-submit">{s.busy ? "Invio…" : "Invia link"}</button>
        </form>
      )}
    </Shell>
  );
}

export function AdminResetPassword() {
  const [params] = useSearchParams();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const s = useSubmit(async () => {
    if (pwd !== pwd2) throw new Error("Le due password non coincidono.");
    await api.post("/auth/reset-password", { token: params.get("token") || "", password: pwd });
    return true;
  });
  return (
    <Shell title="Nuova password" testid="reset-password-page">
      {s.done ? (
        <p className="mt-6 text-sm text-emerald-400" data-testid="reset-password-success">Password aggiornata. Ora puoi accedere con la nuova password.</p>
      ) : (
        <form onSubmit={s.run} data-testid="reset-password-form">
          <p className="mt-1 text-sm text-slate-400">Almeno 10 caratteri, con lettere e numeri.</p>
          <div className="mt-6 space-y-3">
            <input type="password" required minLength={10} value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="Nuova password" autoComplete="new-password" className={field} data-testid="reset-password-input" />
            <input type="password" required minLength={10} value={pwd2} onChange={(e) => setPwd2(e.target.value)} placeholder="Ripeti la password" autoComplete="new-password" className={field} data-testid="reset-password-confirm" />
          </div>
          {s.error && <p className="mt-4 text-sm text-red-400" data-testid="reset-password-error">{s.error}</p>}
          <button disabled={s.busy} className={btn} data-testid="reset-password-submit">{s.busy ? "Salvataggio…" : "Salva nuova password"}</button>
        </form>
      )}
    </Shell>
  );
}
